import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowForward } from '@mui/icons-material';

const HomeServices: React.FC = () => {
  const services = [
    {
      id: 'video-film',
      title: 'Video & Film',
      subtitle: 'Capturing Your Vision with Professional Video',
      description: 'From corporate brand films to documentaries, we have a camera crew on-location to shoot your projects and services. Our skilled editors transform your footage into compelling video products.',
      link: '/services#video-film'
    },
    {
      id: 'branding',
      title: 'Branding',
      subtitle: 'Creating Impactful Brand Identities',
      description: 'We provide comprehensive branding services including logo design, print materials, and brand evaluation. We ensure your brand stands out and creates lasting impressions.',
      link: '/services#branding'
    },
    {
      id: 'digital-content',
      title: 'Digital Content',
      subtitle: 'Enhancing Your Digital Presence',
      description: 'We offer digital content support through photography, graphic design, and podcast production. We help organizations effectively communicate their message across multiple digital platforms.',
      link: '/services#digital-content'
    },
    {
      id: 'creativity-communication',
      title: 'Creativity & Communication',
      subtitle: 'Developing Innovative Concepts',
      description: 'At the heart of every production is the creative concept. Our talented creative team understands your brief to find the most effective way to communicate your story.',
      link: '/services#creativity-communication'
    }
  ];

  return (
    <section id="services" className="py-20 bg-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Image on the left */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="hidden lg:block relative"
          >
            <img 
              src="/pics/service image 2.JPG" 
              alt="Services" 
              className="w-full h-full object-cover rounded-lg"
            />
            {/* Tagline */}
            <div className="absolute bottom-4 right-4">
              <p
                className="text-sm sm:text-base md:text-lg lg:text-xl"
                style={{ 
                  fontFamily: "'HolidayFree', sans-serif",
                  color: '#EF3F23'
                }}
              >
                documenting real life
              </p>
            </div>
          </motion.div>

          {/* Content on the right */}
          <div className="space-y-6 md:space-y-8" style={{ marginTop: '4px' }}>
            {/* Header */}
            <motion.h2
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 md:mb-8"
              style={{ 
                fontFamily: "'Montserrat', sans-serif",
                color: '#EF3F23'
              }}
            >
              What we do
            </motion.h2>

            {/* 2x2 Grid of Service Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
              {services.map((service, index) => (
                <motion.div
                  key={service.id}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="p-4 sm:p-5 md:p-6 rounded-lg shadow-lg flex flex-col"
                  style={{ backgroundColor: '#EF3F23' }}
                >
                  <h3 className="text-xl font-bold mb-3 text-white" style={{ fontFamily: "'Montserrat', 'Poppins', sans-serif" }}>
                    {service.title}
                  </h3>
                  <p className="text-sm mb-4 text-white/80 leading-relaxed line-clamp-2 flex-grow" style={{ fontFamily: "'Poppins', sans-serif" }}>
                    {service.description}
                  </p>

                  <Link
                    to={service.link}
                    className="inline-flex items-center gap-1 text-sm font-semibold text-white hover:text-white/80 transition-colors duration-200 mt-auto"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    View {service.title.toLowerCase()}
                    <ArrowForward style={{ fontSize: '14px' }} />
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeServices;
